/* eslint-disable import/no-default-export */
export default {
  'ClearIconButton.title': 'Clear',
  'CloseButton.title': 'Close',
  'GlAlert.closeButtonTitle': 'Dismiss',
  'GlBanner.closeButtonTitle': 'Dismiss',
  'GlBreadcrumb.showMoreLabel': 'Show more breadcrumbs',
  'GlBroadcastMessage.closeButtonTitle': 'Dismiss',
  'GlChartLegend.average': 'Avg',
  'GlChartLegend.current': 'Current',
  'GlChartLegend.max': 'Max',
  'GlChartLegend.min': 'Min',
  'GlCollapsibleListbox.loadingAnnouncementText.loadingItems': 'Loading items',
  'GlCollapsibleListbox.loadingAnnouncementText.loadingMoreItems': 'Loading more items',
  'GlCollapsibleListbox.loadingAnnouncementText.searching': 'Searching',
  'GlCollapsibleListbox.srOnlyResultsLabel': null,
  'GlDatepicker.monthLabel': 'Month',
  'GlDatepicker.yearLabel': 'Year',
  'GlKeysetPagination.navigationLabel': 'Pagination',
  'GlKeysetPagination.nextText': 'Next',
  'GlKeysetPagination.prevText': 'Previous',
  'GlModal.closeButtonTitle': 'Close',
  'GlPagination.labelFirstPage': 'Go to first page',
  'GlPagination.labelLastPage': 'Go to last page',
  'GlPagination.labelNextPage': 'Go to next page',
  'GlPagination.labelPage': 'Go to page %{page}',
  'GlPagination.labelPrevPage': 'Go to previous page',
  'GlPagination.nav': 'Pagination',
  'GlPagination.nextText': 'Next',
  'GlPagination.prevText': 'Previous',
  'GlProgressBar.ariaLabel': 'Progress bar',
  'GlSearchBoxByType.clearButtonTitle': 'Clear',
  'GlSearchBoxByType.input.placeholder': 'Search',
  'GlSorting.sortByLabel': 'Sort by:',
  'GlSorting.sortAscending': 'Sort direction: ascending',
  'GlSorting.sortDescending': 'Sort direction: descending',
  'GlToken.closeButtonTitle': 'Remove',
};
